import AppForm from './components/form/Form'
import AppCookieModal from './components/CookieModal/CookieModal'
import App from './App'

export default App
export { App, AppForm, AppCookieModal }
